import { useEffect, useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import React from "react";
import { useDispatch } from "react-redux";
import nodeinstance from "../../../../nodeInstance";
import { setAppError } from "../../../../store/userSlice";

export default function Finance_common_PopUp({
  PopUp,
  setPopUp,
  popUpData,
  setTrigger,
  trigger,
  routeType,
}) {
  console.log("sdghtyfgyt..........", popUpData);
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState();
  const [selectedOption, setSelectedOption] = useState({
    govt_cost: "",
    salary: "",
    amount: "",
    sla_fees: "",
  });
  console.log("popUpData..........", popUpData);
  const handleOptionChange = (event) => {
    const { name, value } = event.target;
    setSelectedOption((prevSelectedOption) => ({
      ...prevSelectedOption,
      [name]: value,
    }));
  };
  const [daysUntilExpiry, setDaysUntilExpiry] = useState(null);

  const [data, setData] = useState();

  const response = async () => {
    const endPoint =
      routeType === "Emergency_leave"
        ? `/ere/getDetails/${popUpData?.candidate_id}`
        : routeType === "Annual_Vacation"
          ? `/employeeAnnualvacation/getEmpDetails/${popUpData?.candidate_id}`
          : "";

    try {
      const res = await nodeinstance.get(`${endPoint}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (res.status === 200) {
        setData(res?.data?.data);
      }
    } catch (error) {
      console.log("error.........", error);
      dispatch(
        setAppError({
          msg: "failed to get the data",
        })
      );
    }
  };

  useEffect(() => {
    const calculateDaysUntilExpiry = () => {
      const expiryDate = new Date(popUpData?.iqama_expiry_date_g);
      const today = new Date();

      const timeDifference = expiryDate - today; // Difference in milliseconds
      const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24)); // Convert to days and round up

      setDaysUntilExpiry(daysDifference);
      response();
    };

    calculateDaysUntilExpiry();
  }, []);

  useEffect(() => {
    setSelectedOption((prevSelectedOption) => ({
      ...prevSelectedOption,
      amount: data?.amount,
      sla_fees: data?.sla_fees,
    }));
  }, [data]);
  console.log("jjjjjjj............", selectedOption);
  const token = localStorage.getItem("nodeToken");

  const dispatch = useDispatch();

  const submitHandler = async (e, fileData) => {
    console.log("fileData......", selectedOption);
    e.preventDefault();
    // setLoading(true);
    const endPoint =
      routeType === "Emergency_leave"
        ? "/ere/emergencyLeaveFinance"
        : routeType === "Annual_Vacation"
          ? "/employeeAnnualvacation/annualVacationFinance"
          : "";
    if (selectedOption?.sla_fees != "BORNE") {
      dispatch(
        setAppError({
          msg: "Change sla_fees status to borne",
        })
      );
      return;
    }
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("employee_id", popUpData?.candidate_id);
      formData.append("amount", selectedOption?.amount);
      formData.append("sla_fees", selectedOption?.sla_fees);
      const response = await nodeinstance.put(`${endPoint}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      if (response.status === 200) {
        dispatch(
          setAppError({
            msg: "Updated successfully....",
            color: "success",
          })
        );
        setTrigger(!trigger);
        setPopUp(false);
      }
    } catch (err) {
      console.log("error", err);
      dispatch(
        setAppError({
          msg: "Error while updating data..",
        })
      );
    }
  };

  console.log("daysUntilExpiry......", data);

  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
          PopUp ? "flex" : "hidden"
        }`}
      >
        <div className="max-w-2xl max-h-[45rem]  w-full h-auto mt-4 rounded-md overflow-scroll bg-white/95 flex  flex-col p-4 relative">
          <div className="flex justify-between w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setPopUp(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          {/* First Sheet */}
          <>
            <form onSubmit={(e) => submitHandler(e, file)} className="w-full">
              <div className="bg-orange-50 p-3 ">
                <div className="flex items-center space-x-8 font-bold">
                  <label>PAYROLL & BILLING</label>
                </div>
                <div className="flex gap-2 mb-2 mt-2">
                  <label className="pr-2">GOVT. COST:</label>

                  <div className="flex gap-5">
                    <label className="flex gap-x-1">
                      <input
                        type="radio"
                        name="govt_cost"
                        value="BORNE BY CLIENT"
                        checked={
                          selectedOption?.govt_cost === "BORNE BY CLIENT" ||
                          data?.govt_cost === "BORNE BY CLIENT"
                        }
                        onChange={handleOptionChange}
                        disabled
                      />
                      <p> BORNE BY CLIENT</p>
                    </label>

                    <label className="flex gap-x-1">
                      <input
                        type="radio"
                        value="BORNE BY SLA"
                        name="govt_cost"
                        checked={
                          selectedOption?.govt_cost === "BORNE BY SLA" ||
                          data?.govt_cost === "BORNE BY SLA"
                        }
                        onChange={handleOptionChange}
                        disabled
                      />
                      <p> BORNE BY SLA</p>
                    </label>
                  </div>
                  {/* <p>Selected option: {selectedOption}</p> */}
                </div>
                <div className="flex gap-2">
                  <label className="pr-2">SALARY:</label>

                  <div className="flex gap-5">
                    <label className="flex gap-x-1">
                      <input
                        type="radio"
                        name="salary"
                        value="PAYABLE TO EMPLOYEE"
                        checked={
                          selectedOption?.salary === "PAYABLE TO EMPLOYEE" ||
                          data?.salary === "PAYABLE TO EMPLOYEE"
                        }
                        onChange={handleOptionChange}
                        disabled
                      />
                      <p> PAYABLE TO EMPLOYEE</p>
                    </label>

                    <label className="flex gap-x-1">
                      <input
                        type="radio"
                        name="salary"
                        value="NOT PAYABLE TO EMPLOYEE"
                        checked={
                          selectedOption?.salary ===
                            "NOT PAYABLE TO EMPLOYEE" ||
                          data?.salary === "NOT PAYABLE TO EMPLOYEE"
                        }
                        onChange={handleOptionChange}
                        disabled
                      />
                      <p> NOT PAYABLE TO EMPLOYEE</p>
                    </label>
                  </div>
                  {/* <p>Selected option: {selectedOption}</p> */}
                </div>
              </div>
              <br />
              {/* Second face */}
              <div className="bg-orange-50 p-3">
                <div className="flex items-center space-x-2 ">
                  <label className="font-bold">ERE TYPE</label>
                  <label>COUNT OF PAST ERE INSTANCE: 1</label>
                </div>
                <div className="flex gap-2 mb-2 mt-2">
                  <label className="pr-2">TYPE:</label>

                  <div className="flex gap-5">
                    <label className="flex gap-x-1">
                      <input
                        type="radio"
                        name="ere_type"
                        value="SINGLE"
                        checked={
                          selectedOption?.ere_type === "SINGLE" ||
                          data?.ere_type === "SINGLE"
                        }
                        onChange={handleOptionChange}
                        disabled
                      />
                      <p> SINGLE</p>
                    </label>

                    <label className="flex gap-x-1">
                      <input
                        type="radio"
                        name="ere_type"
                        value="MULTIPLE"
                        checked={
                          selectedOption?.ere_type === "MULTIPLE" ||
                          data?.ere_type === "MULTIPLE"
                        }
                        onChange={handleOptionChange}
                        disabled
                      />
                      <p> MULTIPLE</p>
                    </label>
                  </div>
                  {/* <p>Selected option: {selectedOption}</p> */}
                </div>

                <div className="flex flex-wrap items-center">
                  <label className="mr-2">DURATION:</label>
                  <input
                    type="text"
                    className={`input input-sm h-8 max-w-xs 
                          input-bordered focus:outline-none uppercase`}
                    required
                    value={daysUntilExpiry}
                    disabled
                    // onChange={(e) => {}}
                  />
                  <label className="block font-xs uppercase ml-2 text-xs">
                    IQAMA Valid days remaining: <br /> (today-current IQAMA
                    expiry)
                  </label>
                </div>
              </div>
              <br />
              {/* Second face */}
              <div className="bg-orange-50 p-3">
                <div className="items-center space-x-2 ">
                  <label className="font-bold">FEES</label>
                </div>
                <div className="flex">
                  <div className=" mr-16">
                    <div className="flex gap-2 mb-4 mt-4">
                      <label className="pr-2">Client:</label>

                      <div className="flex gap-5 ">
                        <label className="flex gap-x-1">
                          <input
                            type="radio"
                            name="client_fees"
                            value="BORNE"
                            checked={
                              selectedOption?.client_fees === "BORNE" ||
                              data?.client_fees === "BORNE"
                            }
                            onChange={handleOptionChange}
                            disabled
                          />
                          <p> BORNE</p>
                        </label>

                        <label className="flex gap-x-1">
                          <input
                            type="radio"
                            name="client_fees"
                            value="PAID"
                            checked={
                              selectedOption?.client_fees === "PAID" ||
                              data?.client_fees === "PAID"
                            }
                            onChange={handleOptionChange}
                            disabled
                          />
                          <p> PAID</p>
                        </label>
                      </div>
                      {/* <p>Selected option: {selectedOption}</p> */}
                    </div>

                    <div className="flex gap-2 mb-4 mt-4">
                      <label className="pr-2">SLA:</label>

                      <div className="flex gap-5">
                        <label className="flex gap-x-1">
                          <input
                            type="radio"
                            name="sla_fees"
                            value="BORNE"
                            checked={selectedOption?.sla_fees === "BORNE"}
                            onChange={handleOptionChange}
                          />
                          <p> BORNE</p>
                        </label>

                        <label className="flex gap-x-1">
                          <input
                            type="radio"
                            name="sla_fees"
                            value="TO BE PAID"
                            checked={selectedOption?.sla_fees === "TO BE PAID"}
                            onChange={handleOptionChange}
                          />
                          <p>TO BE PAID</p>
                        </label>
                      </div>
                      {/* <p>Selected option: {selectedOption}</p> */}
                    </div>

                    <div className="flex gap-2 mb-4 mt-4">
                      <label className="pr-2">EMPLOYEE:</label>

                      <div className="flex gap-5">
                        <label className="flex gap-x-1">
                          <input
                            type="radio"
                            name="employee_fees"
                            value="BORNE"
                            checked={
                              selectedOption?.employee_fees === "BORNE" ||
                              data?.employee_fees === "BORNE"
                            }
                            onChange={handleOptionChange}
                            disabled
                          />
                          <p> BORNE</p>
                        </label>
                        <label className="flex gap-x-1">
                          <input
                            type="radio"
                            name="employee_fees"
                            value="PAID"
                            checked={
                              selectedOption?.employee_fees === "PAID" ||
                              data?.employee_fees === "PAID"
                            }
                            onChange={handleOptionChange}
                            disabled
                          />
                          <p> PAID</p>
                        </label>
                      </div>
                      {/* <p>Selected option: {selectedOption}</p> */}
                    </div>
                  </div>
                  <div>
                    <div className="gap-2">
                      <h2 className="label place-items-center font-bold">
                        TOTAL AMOUNT
                      </h2>

                      <div className="gap-5">
                        <input
                          type="number"
                          name="amount"
                          className={`input input-sm h-8 max-w-xs  w-full 
                      input-bordered focus:outline-none uppercase mb-2`}
                          required="er"
                          value={selectedOption?.amount}
                          onChange={handleOptionChange}
                          // onChange={}
                        />
                        <input
                          type="file"
                          className="file-input file-input-bordered w-full h-10"
                          onChange={(e) => setFile(e.target.files[0])}
                          required
                          accept="application/xls, application/xlsx"
                        />
                      </div>
                      {/* <p>Selected option: {selectedOption}</p> */}
                    </div>
                  </div>
                </div>
              </div>
              <br />
              {/* <div className="bg-orange-50 p-3">
            <div className="items-center space-x-2">
              <label className="font-bold">ISSUE ERE</label>
            </div>
            <div className="flex align-center gap-8 mb-5">
              <p>EXIT BEFORE</p>
              <input
                type="date"
                id="field2"
                className={`input input-xl h-8 max-w-xl input-bordered focus:outline-none uppercase`}
                required
              />
            </div>
            <div className="flex align-center gap-8">
              <p>ENTRY BEFORE</p>
              <input
                type="date"
                id="field2"
                className={`input input-xl h-8 max-w-xl input-bordered focus:outline-none uppercase`}
                required
              />
            </div>
            <input
              type="file"
              className="file-input file-input-bordered w-1/2 mt-2"
              onChange={(e) => setFile(e.target.files[0])}
              required
              accept="application/xls, application/xlsx"
            />
          </div> */}
              <br />
              {/* <div className="bg-orange-50 p-3">
            <div className="flex gap-2 mb-4 mt-4">
              <label className="pr-2">CHANGE STATUS:</label>

              <div className="flex gap-5">
                <label className="flex gap-x-1">
                  <input
                    type="radio"
                    value="ERE EXTENSION"
                    checked={selectedOption === "ERE EXTENSION"}
                    onChange={handleOptionChange}
                  />
                  <p> ERE EXTENSION</p>
                </label>

                <label className="flex gap-x-1">
                  <input
                    type="radio"
                    value="NOT RETURN FROM ERE"
                    checked={selectedOption === "NOT RETURN FROM ERE"}
                    onChange={handleOptionChange}
                  />
                  <p> NOT RETURN FROM ERE</p>
                </label>
              </div>
             
            </div>
          </div> */}
              <div className="flex w-full">
                <div className="w-full flex flex-col gap-3">
                  <div className="flex gap-3 w-full justify-center">
                    <button
                      className="p-3 bg-red text-white rounded-md w-full max-w-xs m-2 my-4 flex gap-3 justify-center items-center text-sm"
                      type="submit"
                    >
                      <p>Submit</p>
                      {loading ? <CgSpinner className="animate-spin" /> : ""}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </>
        </div>
      </div>
    </>
  );
}
